export const AI_VISIBILITY = {
  HIDDEN: "HIDDEN",
  AUTO: "AUTO",
};
